import { StorageCore, STORAGE_TOKEN } from "@cems-eco/core/src/services/storage";
import { Service } from "typedi";
import {Container} from "typedi";
@Service(STORAGE_TOKEN)
class StorageService extends StorageCore  {
    [key: string]: any;
    readonly AUTH: string = 'auth';
    readonly SITE_AUTH: any = 'site_auth';
    readonly SITE: string = 'site';
    readonly USER: string = 'user';
    readonly ACCESS: string = 'access';
    readonly PERMISSION: string = 'permission';
    readonly CLIENT: string = 'client';
    readonly LOGIN_TOKEN: string = 'login_token';
    readonly CLIENT_ADV_SEARCH: any = 'client_adv_search';
    readonly SITE_ADV_SEARCH: any = 'site_adv_search';
    readonly EQUIPMENT_ADV_SEARCH: any = 'equipment_adv_search';
    readonly SENSOR_ADV_SEARCH: any = 'sensor_adv_search';
    readonly USER_ADV_SEARCH: any = 'user_adv_search';
    readonly MAINTENANCE_ADV_SEARCH: any = 'maintenance_adv_search';
    readonly ALARM: any = 'alarm';
    readonly SELECTED_EQUIPMENT: any = 'selected_equipment';
    readonly SITE_AUTHS: any = 'site_auths';

    constructor(){
        super();
        this.init();
    }
}


const service: StorageService = Container.get(STORAGE_TOKEN);
export default service;